import { useContext, createContext, FC, PropsWithChildren } from 'react';
import { FieldFacet, List } from 'modules/queryBuilder/legacyQueryBuilder/types';
import { Mapping } from 'api/MappingsAPI';
import { useFieldType } from '../../../hooks/useFieldType';
import { useFieldFacets, useUserMappings, useAllLists } from '../../../hooks';

export type MultiSelectInputContextState = {
  lists: List[];
  userMappings: Mapping[];
  facets: FieldFacet[];
  isListsLoading: boolean;
  isUserMappingsLoading: boolean;
  isFacetsLoading: boolean;
};

export const defaultState = {
  lists: [],
  userMappings: [],
  facets: [],
  isListsLoading: false,
  isUserMappingsLoading: false,
  isFacetsLoading: false,
};

export const MultiSelectInputContext = createContext<MultiSelectInputContextState>(defaultState);
export const useMultiSelectInputContext = () => useContext(MultiSelectInputContext);

export const MultiSelectInputContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const fieldType = useFieldType();
  const { lists, isLoading: isListsLoading } = useAllLists();
  const { facets, isLoading: isFacetsLoading } = useFieldFacets();
  const { userMappings, isLoading: isUserMappingsLoading } = useUserMappings(fieldType);

  const value = {
    lists,
    facets,
    userMappings,
    isListsLoading,
    isFacetsLoading,
    isUserMappingsLoading,
  };

  return (
    <MultiSelectInputContext.Provider value={value}>{children}</MultiSelectInputContext.Provider>
  );
};
